import { Box, ButtonWithLoading } from '@edreamsodigeo/prisma-design-system';
import React from 'react';
import { withDatameshClick } from '@/HOC/withDatamesh';
import { useTranslation, createFeature } from '@edreamsodigeo/frontend-core';
import {
  PRIME_FIRST_PHASE_2_DESKTOP,
  PRIME_FIRST_PHASE_2_MOBILE,
} from '@/versionedComponents';
import { withNativeAware } from '@/HOC/withNativeAware';

const ButtonWithTracking = withDatameshClick(ButtonWithLoading, 'home:button');

const RecognizeUsersHomeButton = ({ disabledRecognizeUsers, ...props }) => {
  return (
    <HomePageButtonContactDetails
      {...props}
      disabled={disabledRecognizeUsers}
    />
  );
};

const PrimeAcquisitionHomeButtonPhase2 = (props) => {
  return <HomePageButtonContactDetails {...props} disabled={false} />;
};

const NativeVersionedHomeContactDetailsButton = createFeature({
  name: PRIME_FIRST_PHASE_2_MOBILE,
  variations: [
    RecognizeUsersHomeButton,
    PrimeAcquisitionHomeButtonPhase2,
    PrimeAcquisitionHomeButtonPhase2,
  ],
  version: 1,
});
export const VersionedHomeContactDetailsButton = withNativeAware(
  NativeVersionedHomeContactDetailsButton,
  PrimeAcquisitionHomeButtonPhase2
);

export const HomePageButtonContactDetails = ({
  onContinueHandler,
  loading,
  disabled = false,
}) => {
  const { t } = useTranslation();
  return (
    <Box px="base">
      <ButtonWithTracking
        disabled={disabled}
        type="primary"
        size="large"
        sx={{ fontWeight: '500' }}
        loading={loading}
        onClick={onContinueHandler}
        nativeType="button"
        fullWidth
        id="pf-home-button"
        data-testid={loading ? 'home_loading' : 'home_idle'}
      >
        {t('home.continue')}
      </ButtonWithTracking>
    </Box>
  );
};

export const VersionedHomeContactDetailsButtonDesktop = createFeature({
  name: PRIME_FIRST_PHASE_2_DESKTOP,
  variations: [
    HomePageButtonContactDetails,
    PrimeAcquisitionHomeButtonPhase2,
    PrimeAcquisitionHomeButtonPhase2,
  ],
  version: 1,
});
